import { createContext, useContext } from "react"

export type LicenseChangesPackage = { Id: number; Name: string }

type LicenseChangesContext = {
  /** Every live package, for the decision cells' pickers. */
  packages: readonly LicenseChangesPackage[]
}

// What every row of the Feature access board shares and no row should
// fetch for itself: the package vocabulary. Provided once by the board
// around the table; the row menus and decision forms read it.
export const LicenseChangesContext = createContext<LicenseChangesContext>({
  packages: [],
})

export function useLicenseChanges() {
  return useContext(LicenseChangesContext)
}
